"use client";

import { useContext, useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import DateRangeContext from "../../../contexts/Dashboard/DateRange";
import { useSelector } from "react-redux";
import axiosInstance from "../../../axiosInstance";
import RecentActivityTimeline from "./recent-activity-timeline";
import FinancialSummaryCharts from "./financial-summary-charts";

const RecentActivities = () => {
  const [loading, setLoading] = useState(true);
  const [recentActivities, setRecentActivities] = useState(null);
  const [timeFilter, setTimeFilter] = useState("all");
  const [userFilter, setUserFilter] = useState("all"); // Kullanıcı filtresi için state ekledik
  const lightMode = useSelector((state) => state.mode.lightMode);

  const { startDate, endDate } = useContext(DateRangeContext);
  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );

  // API'den verileri çekme
  const getRecentActivities = async () => {
    const formattedStartDate = startDate.format("YYYY-MM-DD");
    const formattedEndDate = endDate.format("YYYY-MM-DD");
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_URL}dashboard/recent_activities?start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
    const accessToken = localStorage.getItem("accessToken");
    const token = localStorage.getItem("loginUser");

    try {
      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          XRefreshToken: `${token}`,
          Accounts: selectedBranchesString,
        },
      });

      setRecentActivities(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error occurred during API request:", error);
    }
  };

  useEffect(() => {
    getRecentActivities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, selectedBranchesString]);

  // Zaman filtresini değiştirme işleyicisi
  const handleTimeFilterChange = (newTimeFilter) => {
    setTimeFilter(newTimeFilter);
  };

  // Kullanıcı filtresini değiştirme işleyicisi
  const handleUserFilterChange = (newUserFilter) => {
    setUserFilter(newUserFilter);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={4}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: 600,
          }}
        >
          <RecentActivityTimeline
            recentActivities={recentActivities}
            loading={loading}
            lightMode={lightMode}
            timeFilter={timeFilter}
            onTimeFilterChange={handleTimeFilterChange}
            userFilter={userFilter}
            onUserFilterChange={handleUserFilterChange}
          />
        </Box>
      </Grid>
      <Grid item xs={12} lg={8}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", lg: 600 },
          }}
        >
          <FinancialSummaryCharts
            recentActivities={recentActivities}
            loading={loading}
            lightMode={lightMode}
            timeFilter={timeFilter}
            userFilter={userFilter}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default RecentActivities;
